import { ToneEvenCardCSSStyleImpl } from './tonecard/toneevencardcssstyle';


export class FeaturedCategoryToneEvenCardCSSStyleImpl extends ToneEvenCardCSSStyleImpl
{
    getToneWrapperCSSStyle(marginTop: string): object
    {
        return {
            // height: '280px', 
            // width: '262px', 
            // marginTop: marginTop,
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'0px 50px 0px 50px'
        };
    }
    getOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            // height: '280px', 
            // width: '262px', 
            // borderRadius:'50px 0px 50px 0px',
            display: "flex",
            // paddingLeft: "20px",
            // paddingRight: "20px",
            // paddingTop: "20px",
            background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }
    getMobileToneWrapperCSSStyle(marginTop: string): object
    {
        return {
            // height: '140px', 
            // width: '131px', 
            // marginTop: "40px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'0px 25px 0px 25px'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/toneevencardcssstyle.tsx